import { learnEventStatisticsByNpu } from "./tracker_learn"

export class tracker {
  constructor() {
    this.debugger = false
    this.deviceInfo = this.getDeviceInfo()
    this.terminalInfo = this.getTerminalInfo()
    this.xCasToken = localStorage.getItem('x-cas-token')
    this.codeMap = {
      login_studySpace: {
        name: '学习空间登录记录',
        modal: '学习模块',
        action: '查看'
      }
    }
  }
  /**
   *
   * @param {string} eventAppVersion  APP Version
   * @param {string} eventCode  事件code
   * @param {string} eventDetail  事件详情
   * @param {string} eventEnvDeviceSubType  设备类型详情
   * @param {string} eventEnvDeviceType  设备类型/终端
   * @param {string} eventEnvIp  设备ip
   * @param {string} eventEnvOperationTime  操作时间
   * @param {string} eventEnvOperationUserOrgCode  操作人所属机构代码
   * @param {string} eventEnvOperationUserOrgDetail  操作人所属机构详情
   * @param {string} eventEnvOperationUserOrgName  操作人所属机构名称
   * @param {string} eventEnvOperationUsercode  操作人学号
   * @param {string} eventEnvOperationUsername  操作人姓名
   * @param {string} eventEnvOsName  设备系统名称
   * @param {string} eventEnvOsVersion  设备系统版本号
   * @param {string} eventEnvUserAgent  设备环境
   * @param {string} eventExtraInfo  额外字段
   * @param {string} eventFailureDetail  失败详情
   * @param {string} eventFailureType  失败类型
   * @param {string} eventFuctionLevelOneName  一级功能
   * @param {string} eventFuctionLevelTwoName  二级功能
   * @param {string} eventModel  操作模块
   * @param {string} eventName  事件名称
   * @param {string} eventOpeartionObjectCatelogCode  操作对象所属分类
   * @param {string} eventOpeartionObjectCatelogDetail  操作对象所属分类描述
   * @param {string} eventOpeartionObjectCatelogName  操作对象所属分类名称
   * @param {string} eventOpeartionObjectCode  操作对象code
   * @param {string} eventOpeartionObjectDetail  操作对象内容
   * @param {string} eventOpeartionObjectName  操作对象名称
   * @param {string} eventOpeartionResult  操作结果
   * @param {string} eventOpeartionRoleName  操作人身份名称
   * @param {string} eventOperationUserType  操作人身份类型
   * @param {string} eventSystemName  事件系统名称
   */
  push(courseData) {
    const that = this
    let params = {
      ...(courseData || {}),
      eventEnvDeviceSubType: that.getDeviceInfo(),//设备类型详情
      eventEnvDeviceType: that.getTerminalInfo(),//设备类型/终端
      eventEnvOperationTime: new Date(),//操作时间
      eventEnvOsName: that.getBrowserInfo().browser,//设备系统名称
      eventEnvOsVersion: that.getBrowserInfo().version,//设备系统版本号
      eventEnvUserAgent: navigator.userAgent,//设备环境
      eventOpeartionResult: courseData.eventOpeartionResult || '成功'//操作结果
    }
    const xhr = new XMLHttpRequest();
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200 || xhr.status === 201) {
          try {
            var data = JSON.parse(xhr.responseText);
          } catch (e) {
            console.error
          }
        } else {
          console.error

        }
      }
    };
    xhr.open("POST", "/study-event/v1/event", true);
    xhr.setRequestHeader("X-Device-Info", that.deviceInfo);
    xhr.setRequestHeader("Content-Type", 'application/json');
    if(location.host == 'axxt.nwpu.edu.cn'){
      //正式环境才传值
      xhr.setRequestHeader("X-Id-Token", that.xCasToken);
    }
    xhr.setRequestHeader("X-Terminal-Info", that.terminalInfo);
    xhr.send(JSON.stringify(params));
  }
  getBrowserInfo() {
    var ua = navigator.userAgent;
    var match;
    var browserInfo = {
      browser: null,
      version: null
    };
    if ((match = ua.match(/Chrome\/([\d.]+)/))) {
      browserInfo.browser = 'Chrome';
      browserInfo.version = match[1];
    } else if ((match = ua.match(/Safari\/([\d.]+)/))) {
      browserInfo.browser = 'Safari';
      browserInfo.version = match[1];
    } else if ((match = ua.match(/Edge\/([\d.]+)/))) {
      browserInfo.browser = 'Edge';
      browserInfo.version = match[1];
    } else if ((match = ua.match(/Chrom(e|ium)\/([\d.]+)/))) {
      browserInfo.browser = 'Chrome';
      browserInfo.version = match[2];
    } else if ((match = ua.match(/Trident\/7\..*rv:([\d.]+).*like Gecko/))) {
      // 对于较老的IE版本，可能需要调整此正则表达式
      browserInfo.browser = 'Internet Explorer';
      browserInfo.version = match[1];
    } else if ((match = ua.match(/Firefox\/([\d.]+)/))) {
      browserInfo.browser = 'Mozilla Firefox';
      browserInfo.version = match[1];
    } else {
      browserInfo.browser = 'unknown';
      browserInfo.version = 'unknown';
    }
    // 其他浏览器可以在此处添加

    return browserInfo;
  }
  getDeviceInfo() {
    var userAgent = navigator.userAgent;
    var deviceModel = "Unknown";

    // 检查是否是iOS设备
    if (/iPhone|iPad|iPod/.test(userAgent)) {
      deviceModel = userAgent.match(/(iPhone|iPod|iPad)/)[0];
    }
    // 检查是否是Android设备
    else if (/Android/.test(userAgent)) {
      var match = userAgent.match(/Android\s+([\d.]+);\s*(?:Mobile\s*)?(.+?)\s*Build\/(.*)/);
      if (match && match[2]) {
        deviceModel = match[2]; // 可能是设备型号或运营商信息
      }
    } else {
      deviceModel = 'PC'
    }
    // 其他设备类型可以在此处添加更多条件
    return deviceModel;
  }
  getTerminalInfo() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
    var isMobile = false;
    for (var i = 0; i < mobileAgents.length; i++) {
      if (userAgentInfo.indexOf(mobileAgents[i]) > 0) {
        isMobile = true;
        break;
      }

      if (isMobile) {
        return 'APP'
      } else {
        return 'PC'
      }
    }
  }
}
const _tracker = new tracker()
window._npuTracker = _tracker



/**
 * 西工大事件埋码
 * @param {*} eventCode 事件code
 * @param {*} eventOpeartionObjectCatelogName 操作对象所属分类名称
 * @param {*} eventOpeartionObjectCatelogCode 操作对象所属分类
 * @param {*} eventOpeartionObjectCatelogDetail 操作对象所属分类描述
 * @param {*} eventOpeartionObjectName 操作对象名称
 * @param {*} eventOpeartionObjectCode 操作对象code
 * @param {*} eventOpeartionObjectDetail 操作对象内容
 * @param {*} eventOpeartionResult 成功/失败
 */
export const npuEventStatistics = (params) => {
  const codeMap = {
    login_studySpace: {
      name: '学习空间登录记录',
      modal: '学习模块',
      action: '/',
      detail: '记录用户对学习平台进行登录的操作。'
    },
    online_studySpace: {
      name: '学习空间在线记录',
      modal: '学习模块',
      action: '/',
      detail: '记录用户在学习平台的在线时间。'
    },
    view_courseResources: {
      name: '课程资源点播学习',
      modal: '学习模块',
      action: '查看',
      detail: '记录用户在学习空间进行资源点播学习的操作。'
    },
    download_courseResources: {
      name: '课程资源下载',
      modal: '学习模块',
      action: '查看',
      detail: '记录用户在学习空间进行资源下载的操作。'
    },
    view_courseMap: {
      name: '课程地图学习',
      modal: '学习模块',
      action: '查看',
      detail: '记录用户在学习空间进行课程地图学习的操作。'
    },
    create_quiz: {
      name: '发起提问',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对课程发起提问的操作。'
    },
    create_courseRatings: {
      name: '课程评论评分',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对课程进行评论评分的操作。'
    },
    create_note: {
      name: '添加笔记',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对课程进行添加笔记的操作。'
    },
    update_note: {
      name: '编辑笔记',
      modal: '学习模块',
      action: '编辑',
      detail: '记录用户在学习空间对课程进行编辑笔记的操作。'
    },
    delete_note: {
      name: '删除笔记',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在学习空间对课程进行删除笔记的操作。'
    },
    collect_course: {
      name: '收藏课程',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对课程进行收藏的操作。'
    },
    notCollect_course: {
      name: '取消收藏课程',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在学习空间对课程进行取消收藏的操作。'
    },
    follow_teacher: {
      name: '关注教师',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对教师进行关注的操作。'
    },
    notFollow_teacher: {
      name: '取消关注教师',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在学习空间对教师进行取消关注的操作。'
    },
    subscribe_ourse: {
      name: '订阅课程',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在学习空间对课程进行订阅的操作。'
    },
    notSubscribe_ourse: {
      name: '取消订阅课程',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在学习空间对课程进行取消订阅的操作。'
    },
    view_shortVideos: {
      name: '查看短视频学习',
      modal: '学习模块',
      action: '查看',
      detail: '记录用户在对短视频学进行查看的操作。'
    },
    collect_shortVideos: {
      name: '收藏短视频学习',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在对短视频学进行收藏的操作。'
    },
    share_shortVideos: {
      name: '分享短视频学习',
      modal: '学习模块',
      action: '查看',
      detail: '记录用户在对短视频学进行分享的操作。'
    },
    reserve_liveStreaming: {
      name: '预订直播',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户预订直播的操作。'
    },
    notReserve_liveStreaming: {
      name: '取消预订直播',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户取消预订直播的操作。'
    },
    view_liveStreaming: {
      name: '观看直播',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在对课程中的直播进行发起观看的操作。'
    },
    notView_liveStreaming: {
      name: '取消观看直播',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在对课程中的直播进行发起取消观看的操作。'
    },
    view_liveStreaming: {
      name: '观看录播',
      modal: '学习模块',
      action: '新增',
      detail: '记录用户在对课程中的录播进行发起观看的操作。'
    },
    notView_liveStreaming: {
      name: '取消观看录播',
      modal: '学习模块',
      action: '删除',
      detail: '记录用户在对课程中的录播进行发起取消观看的操作。'
    },
  }
  let event = codeMap[params.eventCode]
  if (window.loginUserInfo && Object.keys(window.loginUserInfo).length && event) {
    let data = {
      ...params,
      eventName: event.name,//事件名称
      eventDetail: event.detail,//事件详情
      eventModel: event.modal,//操作模块
      eventEnvOperationUserOrgCode: window.loginUserInfo.extend.orgcodepath,//操作人所属机构代码
      eventEnvOperationUserOrgName: window.loginUserInfo.extend.orgpath,//操作人所属机构名称
      eventEnvOperationUserOrgDetail: window.loginUserInfo.extend.orgpath,//操作人所属机构详情
      eventEnvOperationUsercode: window.loginUserInfo.user_id,//操作人学号
      eventEnvOperationUsername: window.loginUserInfo.nick_name,//操作人姓名
      eventAppVersion: window.version,//APP Version
      eventOpeartionRoleName: (window.loginUserInfo.roles || []).includes('r-student') ? '学生' : '教师',//操作人身份名称
      eventOperationUserType: (window.loginUserInfo.roles || []).join(','),//操作人身份类型
      eventOpeartionResult: params.eventOpeartionResult || '成功',
      eventOpeartionObjectCatelogDetail: params.eventOpeartionObjectCatelogDetail || params.eventOpeartionObjectCatelogName || '暂无',
      eventSystemName: '门户',//事件系统名称
    }
    learnEventStatisticsByNpu(data) //西工大埋码沿用至平台
    if (window.target_customer != 'npu') {
      return
    }
    window._npuTracker.push(data)
  }
}

/**
 * 通过url获取课程类型名称和code
 */
export const getCourseTypeInfo = () => {
  const codeMap = {
    mooc: '公开课',
    spoc: '班级课',
    training: '培训课',
    videoreview: '在线课堂',
    live: '直播',
    micro: '微课',
    other: '其他'
  }
  let courseTypeCode = 'other'
  Object.keys(codeMap).map(key=>{
    if(window.location.pathname.includes(key)){
      courseTypeCode = key
    }
  })
  const courseTypeName = codeMap[courseTypeCode]
  return { courseTypeName, courseTypeCode }
}